import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Button } from '@/ui'

export const UploadDocumentButton = ({ onClick }: { onClick: () => void }) => (
  <Button iconLeft={solid('cloud-upload')} onClick={onClick} className="w-full">
    Upload Documents
  </Button>
)
